import axios from 'axios';
import {getApiBaseUrl} from '../utils/getApiBaseUrl';
import secureStorage from "../utils/secureStorage";

const API_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: API_URL,
});

// Interceptor para agregar token en headers
api.interceptors.request.use(
  (config) => {
    const token = secureStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);


export const PostOrdenTejido = async (datos) => {
  try {
    const response = await api.post('createOrden', datos); 
    return response.data;
  } catch (error) {
    if (error.response?.data?.message) {
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

export const getOrdenTejido = async () => {
  try {
    const response = await api.get('getOrdenTejido');
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

export const updateEstadoT = async (id, data) => {
  try {
    const response = await api.put(`${API_URL}updateOrden/${id}`, data);

    return response.data;
  } catch (error) {
    throw new Error('Error al Actualizar los Datos: ');
  }
};